<template>
<!-- 装修记 -->
<section class="viewContainer">
  <div v-show="isOrder" @listenEdit="showOrder">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :model="filters" class="findform">
          <el-form-item label="昵称/手机号：" style="display:flex;width:20%" label-width="50px">
            <el-input v-model="filters.channelName" placeholder="请输入昵称 / 手机号 (20字以内)" maxlength="20" style="width:90%"/>
          </el-form-item>
          <el-form-item label="所属城市：" style="display:flex;width:20%">
            <el-cascader v-model="filters.chengshi" placeholder="请选择城市" :options="options"
            filterable clearable @change="handleChange" style="width:90%"/>
          </el-form-item>
          <el-form-item label="日期：" style="display:flex;width:20%">
            <el-date-picker type="daterange" v-model="filters.renovationDate"
            value-format="yyyy-MM-dd" @change="changeActiveTime" style="width:90%"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item label="风格：" style="display:flex;width:20%;" class="select">
            <el-select v-model="filters.stateWithdrawal" filterable placeholder="请选择" style="width:90%">
              <el-option v-for="(item,index) in genderArr" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">装修日记</p>
        <el-button type="danger" @click="showEdit()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
      </section>
      <!-- table 列表 -->
      <div class="table_container">
        <el-table :data="dataList" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="昵称" align="center">
            <template scope="scope">
              <span :title="scope.row.nickName">{{scope.row.nickName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="商品名称" align="center">
            <template scope="scope">{{scope.row.goodsName}}</template>
          </el-table-column>
          <el-table-column label="所属城市" align="center">
            <template scope="scope">{{scope.row.provinceName}} - {{scope.row.cityName}}</template>
          </el-table-column>
          <el-table-column label="小区名称" align="center">
            <template scope="scope">{{scope.row.communityName}}</template>
          </el-table-column>
          <el-table-column label="风格" align="center">
            <template scope="scope">{{scope.row.styleName}}</template>
          </el-table-column>
          <el-table-column label="面积" align="center">
            <template scope="scope">{{scope.row.houseSize}}</template>
          </el-table-column>
          <el-table-column label="发布日期" align="center">
            <template scope="scope">{{scope.row.cTime}}</template>
          </el-table-column>
          <el-table-column label="评论" align="center">
            <template scope="scope">
              <span @click="endToExamine(scope.row)" :style="{color: scope.row.commentCount == 0 ? '#ccc' : '#6786b4'}">
                {{scope.row.commentCount}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="235">
            <template scope="scope">
              <span class="handle" @click="emitinfo(scope.row,2)"> <i class="el-icon-view"></i> 查看 </span>
              <span class="handle" @click="emitinfo(scope.row,1)"> <i class="el-icon-edit-outline"></i> 编辑 </span>
              <span class="handle" @click="deleteMerchant(scope.row)"> <i class="el-icon-delete"></i> 删除 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
      </div>
    </div>
  </div>
  <!-- 装修日记 详情页 -->
  <div class="main_container" v-if="isOrderWatch" style="padding-bottom: 20px;">
    <section class="model_section">
      <p class="model_top_title">装修日记 详情页</p>
    </section>
    <!-- 新增/编辑装修日记 -->
    <el-form class="decorationDiaryDiv">
      <el-form class="decorationDiaryElForm">
        <el-form-item label="日记名称 :" style="width:40%;" label-width="88px">
          <el-input v-model="decorationDiary.diaryName" placeholder="请输入日记名称 (20字以内)"
          maxlength="20" style="width:80%" :disabled="decorationSeeDis"/>
        </el-form-item>
        <el-form-item label="装修公司 :" style="width:40%;" label-width="88px">
          <el-select v-model="decorationDiary.decorationCompany" placeholder="请选择" style="width: 80%"
            :disabled="decorationSeeDis" @change="zhuangxiugongsi($event)">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in decorationCompanyArr" :key="index"/>
          </el-select>
        </el-form-item>
        <el-form-item label="选择商品 :" style="width:20%;" label-width="88px">
          <el-select v-model="decorationDiary.commodity" placeholder="请选择" style="width: 80%" :disabled="decorationSeeDis">
            <el-option :label="item.goodsName" :value="item.id" v-for="(item, index) in commodityArr" :key="index"/>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form class="decorationDiaryElForm">
        <el-form-item label="所属城市 :" style="width:40%;" label-width="88px">
          <el-cascader v-model="decorationDiary.shengshi" placeholder="请选择城市" style="width:80%"
          :options="optionDetails" filterable clearable @change="addHandleChangeDetails" :disabled="decorationSeeDis"/>
        </el-form-item>
        <el-form-item label="小区名称 :" style="width:40%;" label-width="88px">
          <el-input v-model="decorationDiary.communityName" placeholder="请输入小区名称" maxlength="20"
            style="width:80%" :disabled="decorationSeeDis"/>
        </el-form-item>
        <el-form-item label="户型 :" style="width:20%;" label-width="88px">
          <el-select v-model="decorationDiary.houseType" filterable placeholder="请选择"
            style="width:80%" :disabled="decorationSeeDis">
            <el-option v-for="(item,index) in houseTypeArr" :key="index" :label="item.Name" :value="item.Id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form class="decorationDiaryElForm">
        <el-form-item label="装修风格 :" style="width:40%;" label-width="88px">
          <el-select v-model="decorationDiary.decorationStyle" placeholder="请选择" style="width: 80%" :disabled="decorationSeeDis">
            <el-option :label="item.Name" :value="item.Id" v-for="(item, index) in decorationStyleArr" :key="index"/>
          </el-select>
        </el-form-item>
        <el-form-item label="房屋面积 :" style="width:20%;" label-width="88px">
          <el-input v-model="decorationDiary.housingArea" placeholder="请输入房屋面积" style="width: 80%"
            maxlength="5" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" :disabled="decorationSeeDis"/>
          <span style="margin-left: 10px;">平米</span>
        </el-form-item>
      </el-form>
      <el-form class="decorationDiaryElForm">
        <el-form-item label="装修工期 :" style="width:40%;" label-width="88px">
          <el-input v-model="decorationDiary.decorationPeriod" placeholder="请输入装修工期" style="width: 80%"
            maxlength="3" onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" :disabled="decorationSeeDis"/>
          <span style="margin-left: 10px;">天</span>
        </el-form-item>
        <el-form-item label="发布用户 :" style="width:40%;" label-width="88px">
          <div class="publishingUsers">
            <el-button type="warning" class="publisherBtn" @click="handleAddPublisher" v-if="hideDecoration"> 添加发布用户 </el-button>
            <b class="releaseName">{{publisherTitle}}</b>
            <img v-if="headPortrait" :src="headPortrait" class="avatar fbrLogo"/>
          </div>
        </el-form-item>
        <el-form-item label="发布日期 :" style="width:20%;" label-width="88px">
          <el-date-picker type="date" v-model="releaseDate" :editable="false"
            value-format="yyyy-MM-dd" :disabled="decorationSeeDis"/>
        </el-form-item>
      </el-form>
      <el-form class="decorationDiaryElForm">
        <el-form-item label="装修记封面 :" style="width:40%;" label-width="88px">
          <div v-if="coverImageUrlOne" style="width: 88px;position: relative;">
            <img src="../../assets/img/aicon36.png" @click="coverImageUrlOne=''" v-show="!decorationSeeDis"
            style="position:absolute;right:0;top:-8px;z-index: 1;width: 20px;"/>
            <el-image :src="coverImageUrlOne" fit="cover" @click="handleClickItem" :preview-src-list="[coverImageUrlOne]" style="width:80px;height:80px"/>
          </div>
          <div v-else class="upload" style="display:inline-block">
            <el-upload class="avatar-uploader" action :show-file-list="false"
              :before-upload="(file)=>beforeUnitPlan(file, 1)" :disabled="decorationSeeDis">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="color:#888;">建议尺寸：1200*675，支持的图片格式：jpg、png !</div>
        </el-form-item>
        <el-form-item label="户型平面图 :" style="width:40%;" label-width="88px">
          <div v-if="coverImageUrlTwo" style="width: 88px;position: relative;">
            <img src="../../assets/img/aicon36.png" @click="coverImageUrlTwo=''" v-show="!decorationSeeDis"
            style="position:absolute;right:0;top:-8px;z-index: 1;width: 20px;"/>
            <el-image :src="coverImageUrlTwo" fit="cover" @click="handleClickItem" :preview-src-list="[coverImageUrlTwo]" style="width:80px;height:80px"/>
          </div>
          <div v-else class="upload" style="display:inline-block">
            <el-upload class="avatar-uploader" action :show-file-list="false"
              :before-upload="(file)=>beforeUnitPlan(file, 2)" :disabled="decorationSeeDis">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="color:#888;">建议尺寸：1200*675，支持的图片格式：jpg、png !</div>
        </el-form-item>
      </el-form>
      <canvas id="canvasa" hidden/>
    </el-form>
    <div style="border-top: 2px dashed #ccc;"></div>
    <!-- 以下为虚线区域 -->
    <el-form class="dottedLine" v-for="(item,index) in journalArr" :key="index">
      <template v-if="journalArr.length >= 1">
        <div class="sahnchuDiv" v-if="hideDecoration"><el-button type="warning" @click="shanchu(index)">刪除</el-button></div>
        <el-form-item label="选择日期 :" style="width:80%;" label-width="80px">
          <el-date-picker type="date" v-model="item.cTime" :editable="false" value-format="yyyy-MM-dd" :disabled="journalSeeDisList"/>
        </el-form-item>
        <el-form-item label="备注 :" style="width:80%;" label-width="80px">
          <el-input type="textarea" v-model="item.content" show-word-limit style="width:80%"
          :disabled="journalSeeDisList" :autosize="{ minRows: 3, maxRows: 6}" maxlength="100"/>
        </el-form-item>
        <el-form-item label="多图上传 :" style="width:80%;" label-width="80px">
          <div class="upPictures">
            <div class="multigraph" v-for="(item,index) in item.images" :key="index" :data-img="item">
              <el-image :src="item" fit="cover" @click="handleClickItem" :preview-src-list="[item]"
              style="width: 80px; height:80px"/>
            </div>
          </div>
        </el-form-item>
      </template>
    </el-form>
    <el-form class="dottedLine" v-if="hideDecoration">
      <el-form-item label="选择日期 :" style="width:80%;" label-width="80px">
        <el-date-picker type="date" v-model="selectDate" :editable="false" value-format="yyyy-MM-dd" placeholder="选择日期"/>
      </el-form-item>
      <el-form-item label="备注 :" style="width:80%;" label-width="80px">
        <el-input type="textarea" v-model="anwser" placeholder="当天的装修笔记标题或者内容（例如：今天是装修第一天，先来晒晒现在的样子吧~~）"
        :autosize="{ minRows: 3, maxRows: 6}" maxlength="1000" show-word-limit style="width:80%"/>
      </el-form-item>
      <el-form-item label="多图上传 :" style="width:80%;" label-width="80px">
        <div class="upPictures">
          <div class="multigraph" v-for="(item,index) in detailImgUrlarr" :key="index" :data-img="item">
            <el-image :src="item" fit="cover" @click="handleClickItem" :preview-src-list="detailImgUrlarr"
            style="width: 80px; height:80px"/>
            <div class="chahao" @click.stop="deldetail(index)">
              <img src="../../assets/img/aicon36.png"/>
            </div>
          </div>
          <!-- 上传图片 -->
          <el-upload action multiple v-if="flag < 15" :before-upload="beforeAvatarUpload" accept=".png, .jpg,.jpeg">
            <i class="el-icon-plus upBtn"></i>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>
    <div class="primarybtn"><el-button type="primary" @click="addJournal()" v-if="hideDecoration">增加日志</el-button></div>

    <!-- 弹框按钮 -->
    <div class="gudingdibu">
      <el-button @click="showOrder()">{{ decorationSeeDis?'返回':'取消' }}</el-button>
      <el-button type="danger" @click="addAndPreservation()" v-if="hideDecoration">保存并发布</el-button>
    </div>
  </div>
    
  <!-- 评论管理-弹框 -->
  <el-dialog title="评论管理" :visible.sync="isToComment" width="50%">
    <el-table :data="activeOrderList">
      <el-table-column label="序号" align="center">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="name" label="评论用户" align="center"/>
      <el-table-column property="userType" label="用户身份" align="center"/>
      <el-table-column property="content" label="评论内容" align="center"/>
      <el-table-column property="cTime" label="评论时间" align="center"/>
      <el-table-column label="操作" fixed="right" align="center">
        <template scope="scope">
          <span class="handle" @click="deleteComment(scope.row)"> <i class="el-icon-delete"></i> 删除 </span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination layout="prev, pager, next" @current-change="handleComment"
      :page-size="10" :current-page="pageIndexComment" :total="totalComment" class="paginationFy"/>
  </el-dialog>
  <!-- 选择发布用户 -->
  <el-dialog title="选择发布用户" :visible.sync="dialogVisibledis" width="40%" center>
    <el-form style="display:flex;" label-width="130px">
      <el-form-item label="发布用户手机号：" style="width:50%;margin-right:10px;">
        <el-input v-model="publisherPhone" placeholder="请输入发布用户手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="finddes()">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="disoutline">
      <p @click="handleGetdesId(item)" v-for="(item,index) in desarr" :key="index" class="disinline">
        <img :src="item.faceUrl"/>
        <span>{{item.nickName}}</span>
        <el-radio v-model="choiceRadioId" :label="item.id" class="elRadio">选择</el-radio>
      </p>
      <p style="text-align:center" v-show="nofind">查无结果</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibledis = false">取 消</el-button>
      <el-button type="danger" @click="makedes()">确 定</el-button>
    </div>
  </el-dialog>
  <!-- vueCropper 剪裁图片实现-->
  <el-dialog title="图片剪裁" :visible.sync="cropping" append-to-body center>
    <div class="cropper-content">
      <div class="cropper">
        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :fixedBox="option.fixedBox"
        :outputType="option.outputType" :full="option.full" :canMove="option.canMove" :infoTrue="option.infoTrue"
        :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :info="true"
        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
        :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"/>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cropping = false">取 消</el-button>
      <el-button type="primary" @click="finish">确认</el-button>
    </div>
  </el-dialog>
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss'; // oss上传
import {getkind} from "../../api/api";
import { getOssFile, provincegetcountys } from '../../api/newOss';
import { dcSelectLable, packageGoodsSelectLable, getArticleVideoJzUser,
  getDecorationList, getDecorationCommentsList, postDecorationAdd, getDecorationDetails, putDecorationEdit,
  deleteDecoration, deleteComments } from "../../api/decoration";
export default {
  name: 'decoration',
  mixins: [alertTrends],
  data() {
    return {
      show3: true, // 查询区域默认展开
      isOrder: true, // 主页
      isOrderWatch: false, // 详情页
      decorationId: "", // id
      commentId: "", // 装修记id
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      filters: {
        channelName: "", // 昵称
        chengshi: "", // 所属城市
        renovationDate: "", // 日期
        stateWithdrawal: 0, // 状态
      },
      provinceId: 0, // 省id
      cityId: 0, // 市id
      startTime: "", // 开始时间
      endTime: "", // 结束时间
      options: [
        {
          value: 0,
          label: "全部",
        },
      ],
      genderArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "现代简约"
        },
        {
          Id: 2,
          Name: "欧式"
        },
      ],
      houseTypeArr: [
        {
          Id: '一室',
          Name: "一室"
        },
        {
          Id: '二室',
          Name: "二室"
        },
        {
          Id: '三室',
          Name: "三室"
        },
        {
          Id: '四室',
          Name: "四室"
        },
        {
          Id: '五室',
          Name: "五室"
        },
        {
          Id: '六室',
          Name: "六室"
        },
        {
          Id: '七室',
          Name: "七室"
        },
        {
          Id: '八室',
          Name: "八室"
        },
        {
          Id: '九室',
          Name: "九室"
        },
        {
          Id: '十室',
          Name: "十室"
        },
      ],
      isToComment: false, // 评论弹框
      pageIndexComment: 1,
      totalComment: 10,
      activeOrderList: [], // 评论列表

      decorationSeeDis: false, // 置灰
      hideDecoration: true, // 隐藏元素
      decorationDiary: {
        diaryName: "", // 日记名称
        decorationCompany: '', // 装修公司
        commodity: "", // 选择商品
        shengshi: "", // 所属城市
        communityName: "", // 小区名称
        houseType: "", // 户型
        decorationStyle: "", // 装修风格
        housingArea: "", // 房屋面积
        decorationPeriod: "", // 装修工期
      },
      decorationCompanyArr: [], // 装修公司
      commodityArr: [], // 选择商品
      optionDetails: [],
      provinceDetailsId: 0, // 省id
      cityDetailsId: 0, // 市id
      decorationStyleArr: [], // 装修风格

      // 发布用户
      publisherTitle: "", // 发布用户名称回显
      headPortrait: "", // 头像 - 全链接回显
      releaseDate: "", // 发布时间
      
      dialogVisibledis: false, // 选择发布用户弹框
      publisherPhone: "", // 发布用户手机号
      desarr: [], // 发布用户列表
      choiceRadioId: 0, // 发布用户id
      choiceRadioName: "", // 发布用户姓名
      choiceRadioHeadPortrait: "", // 发布用户头像
      nofind:false, // 查无结果
      
      // 装修记封面
      coverImageUrlOne: "",
      coverImageUrlOneQiege: "",
      // 户型平面图
      coverImageUrlTwo: "",
      coverImageUrlTwoQiege: "",

      journalSeeDisList: true, // 禁用
      journalArr: [], // 日志集合
      selectDate: "", // 选择日期
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() < Date.now() - 8.64e7;
      //   }
      // },
      anwser: '', // 备注
      detailImgUrlarr: [], // 多图集合
      flag: 0,
      cropping: false, // 图片裁剪弹框
      distinguish: '', // 区分两个上传图片
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1200, // 默认生成截图框宽度
        autoCropHeight: 675, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1200, 675], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
    }
  },
  methods: {
    // 查询列表
    getInit() {
      let addParams = {
        UserId: localStorage.Id, // 当前登录人id
        Key: this.filters.channelName, // 昵称
        ProvinceId: this.provinceId, // 省id
        CityId: this.cityId, // 市id
        BeginTime: this.startTime, // 开始时间
        EndTime: this.endTime, // 结束时间
        StyleId: this.filters.stateWithdrawal, // 风格id
        pageIndex: this.pageIndex,// 页码
        PageSize: this.pageSize // 条数
      };
      getDecorationList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.resultObj;
            this.totalRowsCount = data.resultObj.rowsCount;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      })
    },
    // 评论
    endToExamine(row) {
      this.commentId = row.id;
      if (row.commentCount == 0) { return; }
      this.isToComment = true;
      this.commentList()
    },
    // 查询评论列表
    commentList() {
      var obj = {
        id: this.commentId, // 装修记id
        pageIndex: this.pageIndexComment, // 页码
        pageSize: 10, // 条数
      };
      getDecorationCommentsList(obj).then((data) => {
        if(data) {
          if (data.resultCode == 1) {
            this.activeOrderList = data.resultObj.resultObj;
            this.totalComment = data.resultObj.rowsCount;
          } else {
            this.activeOrderList = [];
          }
        } else {
          this.activeOrderList = [];
        }
      });
    },
    // 显示主页
    showOrder() {
      this.isOrder = true; // 主页
      this.isOrderWatch = false; // 详情页
    },
    // 新增
    showEdit() {
      this.decorationSeeDis = false, // 置灰
      this.hideDecoration = true, // 隐藏元素
      
      this.decorationId = "";
      this.isOrder = false; // 主页
      this.isOrderWatch = true; // 详情页
      this.getDecorationCompany(); // 装修公司
      this.getDecorationStyle(); // 装修风格
      this.decorationDiary.diaryName = "";
      this.decorationDiary.decorationCompany = ""; // 装修公司
      this.decorationDiary.commodity = ""; // 选择商品
      this.decorationDiary.shengshi = "";
      this.decorationDiary.communityName = "";
      this.decorationDiary.houseType = "";
      this.decorationDiary.decorationStyle = "";
      this.decorationDiary.housingArea = "";
      this.decorationDiary.decorationPeriod = "";
      this.publisherTitle = ""; // 清空发布用户名称
      this.headPortrait = ""; // 清空发布用户头像
      this.releaseDate = ""; // 清空发布时间
      this.coverImageUrlOne = ""; //  清空装修记封面图
      this.coverImageUrlTwo = ""; //  清空户型平面图
      this.journalArr = []; // 清空日志集合
      this.selectDate = "";
      this.anwser = "";
      this.detailImgUrlarr = [];
    },
    // 编辑 & 查看
    emitinfo(row,type) {
      if(type==1){ // 编辑
        this.decorationSeeDis = false // 置灰
        this.hideDecoration = true // 隐藏元素
      }else{ // 查看
        this.decorationSeeDis = true // 置灰
        this.hideDecoration = false // 隐藏元素
      }
      
      this.decorationId = row.id;
      this.isOrder = false; // 主页
      this.isOrderWatch = true; // 详情页
      this.getDecorationCompany(); // 装修公司
      this.getDecorationStyle(); // 装修风格
      this.selectDate = "";
      this.anwser = "";
      this.detailImgUrlarr = [];
      // 调用回显接口
      let obj = { id: this.decorationId };
      getDecorationDetails(obj).then(data => {
        if (data.resultCode == 1) {
          let decorationEcho = data.resultObj;
          this.decorationDiary.diaryName = decorationEcho.name;
          this.decorationDiary.decorationCompany = decorationEcho.bbid; // 装修公司
          this.decorationDiary.commodity = decorationEcho.windowGoodsId; // 选择商品
          this.provinceDetailsId = decorationEcho.provinceId, // 省
          this.cityDetailsId = decorationEcho.cityId, // 市
          this.decorationDiary.shengshi = [decorationEcho.provinceId, decorationEcho.cityId];
          this.decorationDiary.communityName = decorationEcho.communityName;
          this.decorationDiary.houseType = decorationEcho.houseType;
          this.decorationDiary.decorationStyle = decorationEcho.styleId;
          this.decorationDiary.housingArea = decorationEcho.houseSize;
          this.decorationDiary.decorationPeriod = decorationEcho.constructionPeriod;
          this.releaseDate = decorationEcho.releaseDate;
          this.choiceRadioId = decorationEcho.publishId; // 发布人id
          this.publisherTitle = decorationEcho.publishName;
          this.headPortrait = decorationEcho.publishFace;
          this.coverImageUrlOne = localStorage.BaseOssUrl + decorationEcho.coverImgUrl; // 封面图 - 全链接
          this.coverImageUrlOneQiege = decorationEcho.coverImgUrl; // 封面图 - 短连接
          this.coverImageUrlTwo = localStorage.BaseOssUrl + decorationEcho.planImgUrl; // 平面图 - 全链接
          this.coverImageUrlTwoQiege = decorationEcho.planImgUrl; // 平面图 - 短连接
          // 处理日志集合-多图回显
          let newDataArr = JSON.parse(JSON.stringify(decorationEcho.record));
          for(var i = 0; i < newDataArr.images; i++) {
            newDataArr[i] = newDataArr[i].replace('', localStorage.BaseUrl)
          }
          this.journalArr = newDataArr; // 日志集合
          
        }
      });
    },
    // 删除
    deleteMerchant(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = row.id;
          deleteDecoration(obj).then(data => {
            if (data.resultCode == 1) {
              this.showAlert('删除成功', 'success');
              this.getInit();
            }
          });
        }
      });
    },
    // 删除评论
    deleteComment(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = {
            id: row.id
          };
          deleteComments(obj).then(data => {
            if (data.resultCode == 1) {
              this.showAlert('删除成功', 'success');
              this.getInit();
            }
          });
        }
      });
    },
    // 增加日志
    addJournal() {
      if(this.selectDate == ''){
        this.showAlert('请选择日期');
        return false;
      }
      if(this.anwser == ''){
        this.showAlert('请输入备注说明');
        return false;
      }
      if(this.detailImgUrlarr.length == 0){
        this.showAlert('请至少上传一张图片');
        return false;
      }
      // 处理重复时间
      if(this.journalArr.find(item => item.cTime == this.selectDate)) {
        this.showAlert('日期不能重复');
        return false;
      }

      this.journalArr.push({cTime: this.selectDate, content: this.anwser, images: this.detailImgUrlarr})
      this.selectDate = '' // 清空时间
      this.anwser = '' // 清空备注
      this.detailImgUrlarr = []
    },
    // 刪除日志
    shanchu(index) {
      this.journalArr.splice(index, 1);
    },
    
    // 保存并发布
    addAndPreservation() {
      if(this.decorationDiary.diaryName == ''){
        this.showAlert('请输入日记名称');
        return false;
      }
      if(this.decorationDiary.decorationCompany == ''){
        this.showAlert('请选择装修公司');
        return false;
      }
      if(this.decorationDiary.commodity == ''){
        this.showAlert('请选择商品');
        return false;
      }
      if(this.decorationDiary.shengshi == ''){
        this.showAlert('请选择省份城市');
        return false;
      }
      if(this.decorationDiary.communityName == ''){
        this.showAlert('请输入小区名称');
        return false;
      }
      if(this.decorationDiary.houseType == ''){
        this.showAlert('请输入户型');
        return false;
      }
      if(this.decorationDiary.decorationStyle == ''){
        this.showAlert('请选择装修风格');
        return false;
      }
      if(this.decorationDiary.housingArea == ''){
        this.showAlert('请输入房屋面积');
        return false;
      }
      if(this.decorationDiary.decorationPeriod == ''){
        this.showAlert('请输入装修工期');
        return false;
      }
      if(this.releaseDate == '') {
        this.showAlert('请选择发布日期');
        return false;
      }
      if(this.headPortrait == ""){
        this.showAlert('请添加发布用户');
        return false;
      }
      if(this.coverImageUrlOne == ''){
        this.showAlert('请上传装修记封面');
        return false;
      }
      if(this.coverImageUrlTwo == ''){
        this.showAlert('请上传户型平面图');
        return false;
      }
      if(this.journalArr.length == 0){
        this.showAlert('请至少增加一项日志');
        return false;
      }
      if(this.decorationId) {
        var addParams = {
          id: this.decorationId, // 装修记id
          operator: localStorage.Id, // 操作人id
          name: this.decorationDiary.diaryName, // 名称
          bbid: this.decorationDiary.decorationCompany, // 装修公司id
          windowGoodsId: this.decorationDiary.commodity, // 关联商品id
          provinceId: this.provinceDetailsId, // 省
          cityId: this.cityDetailsId, // 市
          communityName: this.decorationDiary.communityName, // 小区名称
          houseType: this.decorationDiary.houseType, // 户型
          styleId: this.decorationDiary.decorationStyle, // 风格
          houseSize: this.decorationDiary.housingArea, // 面积
          constructionPeriod: this.decorationDiary.decorationPeriod, // 装修工期
          publishId: this.choiceRadioId, // 发布人
          releaseDate: this.releaseDate, // 发布日期
          coverImgUrl: this.coverImageUrlOneQiege, // 封面图
          planImgUrl: this.coverImageUrlTwoQiege, // 平面图
          record: this.journalArr, // 装修记记录集合
        };
        putDecorationEdit(addParams).then(data => {
          if(data.resultCode == 1) {
            this.showAlert(data.resultMsg, 'success');
            this.isOrder = true; // 主页
            this.isOrderWatch = false; // 详情页
            this.getInit();
          } else {
            this.showAlert(data.resultMsg);
          }
        })
      } else {
        var addParams = {
          operator: localStorage.Id, // 操作人id
          name: this.decorationDiary.diaryName, // 名称
          bbid: this.decorationDiary.decorationCompany, // 装修公司id
          windowGoodsId: this.decorationDiary.commodity, // 关联商品id
          provinceId: this.provinceDetailsId, // 省
          cityId: this.cityDetailsId, // 市
          communityName: this.decorationDiary.communityName, // 小区名称
          houseType: this.decorationDiary.houseType, // 户型
          styleId: this.decorationDiary.decorationStyle, // 风格
          houseSize: this.decorationDiary.housingArea, // 面积
          constructionPeriod: this.decorationDiary.decorationPeriod, // 装修工期
          publishId: this.choiceRadioId, // 发布人
          releaseDate: this.releaseDate, // 发布日期
          coverImgUrl: this.coverImageUrlOneQiege, // 封面图
          planImgUrl: this.coverImageUrlTwoQiege, // 平面图
          record: this.journalArr, // 装修记记录集合
        };
        postDecorationAdd(addParams).then(data => {
          if(data.resultCode == 1) {
            this.showAlert(data.resultMsg, 'success');
            this.isOrder = true; // 主页
            this.isOrderWatch = false; // 详情页
            this.getInit();
          } else {
            this.showAlert(data.resultMsg);
          }
        })
      }
    },
    // 点击选择发布用户
    handleAddPublisher() {
      this.publisherPhone = "";
      this.dialogVisibledis = true;

      var obj = {
        key: this.publisherPhone // 发布用户手机号
      };
      getArticleVideoJzUser(obj).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.desarr = data.resultObj;
            this.nofind = false;
          } else {
            this.desarr = [];
            this.nofind = true;
          }
        } else {
          this.desarr = [];
          this.nofind = true;
        }
      });
    },
    // 查询发布用户
    finddes() {
      var obj = {
        key: this.publisherPhone // 发布用户手机号
      };
      getArticleVideoJzUser(obj).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.desarr = data.resultObj;
            this.nofind = false;
          } else {
            this.desarr = [];
            this.nofind = true;
          }
        } else {
          this.desarr = [];
          this.nofind = true;
        }
      });
    },
    // 选中发布用户区域
    handleGetdesId(val) {
      this.choiceRadioId = val.id; // 获取发布用户id
      this.choiceRadioName = val.nickName; // 获取发布用户姓名
      this.choiceRadioHeadPortrait = val.faceUrl; // 获取发布用户头像
    },
    // 确定选择发布用户
    makedes() {
      this.dialogVisibledis = false;
      this.publisherTitle = this.choiceRadioName; // 赋值发布用户名称
      this.headPortrait = this.choiceRadioHeadPortrait; // 赋值发布用户头像
    },
    // 重置
    fnReset() {
      this.filters = {
        channelName: "", // 昵称
        chengshi: "", // 所属城市
        renovationDate: "", // 日期
        stateWithdrawal: 0, // 状态
      }
      this.provinceId = 0; // 省id
      this.cityId = 0; // 市id
      this.startTime = "";
      this.endTime = "";
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
    // 评论管理列表 - 分页
    handleComment(val) {
      this.pageIndexComment = val;
      this.commentList();
    },
    // 活动时间转换
    changeActiveTime(time) {
      this.startTime = time[0];
      this.endTime = time[1];
    },
    // 请选择所属城市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 详情页 所属城市
    addHandleChangeDetails(val) {
      this.provinceDetailsId = val[0];
      this.cityDetailsId = val[1];
    },
    // 查找所属城市
    getprovince() {
      var loginParams = {
        isopen: 1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 省
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname};
            provinceData.children.push(cityData);
          })
        });
        that.options = provinceAndCityAndarea;
        that.optionDetails = provinceAndCityAndarea;
      })
    },
    // 获取装修公司
    getDecorationCompany() {
      let that = this;
      let obj = {
        userId: localStorage.Id
      }
      dcSelectLable(obj).then(data => {
        that.decorationCompanyArr = data.resultObj;
      })
    },
    // 点击装修公司
    zhuangxiugongsi(val) {
      this.decorationDiary.commodity = "";
      // 获取选择商品
      let that = this;
      let obj = {
        id: val, // 装修公司id
      }
      packageGoodsSelectLable(obj).then(data => {
        if(data) {
          if(data.resultCode == 1) {
            that.commodityArr = data.resultObj;
          }
          if(data.resultCode == 4) {
            that.commodityArr = [];
          } 
        } else {
          that.commodityArr = [];
        }
      })
    },
    // 获取装修风格
    getDecorationStyle() {
      let that = this;
      var loginParams = {
        tableName: "tBD柜_风格",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        that.decorationStyleArr = data.ResultObj;
      })
    },
    // 装修记封面 & 户型平面图
    beforeUnitPlan(file, type) {
      this.distinguish = type; // 区分
      const isJPG = file.type
      if (isJPG !='image/jpeg'&&isJPG !='image/png'){
        this.showAlert("上传图片格式应为jpg/png");
        return false
      }
      const isSize = new Promise(function(resolve, reject) {
        let width = 1200;
        let height = 675;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          that.handleOss(16); // oss 直传图片
          var newOssPic = await uploadOSS(file,0);
          // 装修记封面
          if(type == 1) {
            that.coverImageUrlOne = newOssPic;
            that.coverImageUrlOneQiege = newOssPic.replace(localStorage.BaseOssUrl,'')
          }
          // 户型平面图
          if(type == 2) {
            that.coverImageUrlTwo = newOssPic;
            that.coverImageUrlTwoQiege = newOssPic.replace(localStorage.BaseOssUrl,'')
          }
          that.cropping = false; // 图片裁剪弹框
        };
      },() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // 上传成功后将图片地址赋值给裁剪框显示图片
          that.$nextTick(() => {
            that.option.img = e.target.result
            that.cropping = true; // 图片裁剪弹框
            setTimeout(()=>{
              // document.querySelector('.crop-info').setHTML("1200 x 675")
              document.querySelector('.crop-info').innerHTML = '1200 x 675'
            },300)
          })
          return
        };
        // this.showAlert("上传图片宽高应为1200*675");
      });
    },
    
    // 多图上传
    beforeAvatarUpload(file) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 1;
      if (!isJPG) {
        this.showAlert('上传图片只支持jpg、png等格式');
        return;
      }
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 1MB');
        return;
      }
      var _this = this;
      this.flag += 1;
      if (this.flag > 15) {
        this.showAlert('最多传入15张图片');
        return false;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        _this.handleOss(16); // oss 直传图片
        var newOssPic = await uploadOSS(file,0);
        _this.detailImgUrlarr.push(newOssPic);
        
      };
      return file;
    },
    // 删除上传图片
    deldetail(val) {
      let newdetailImgUrlarr = this.detailImgUrlarr;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        if (val == i) {
          newdetailImgUrlarr.splice(i, 1);
        }
      }
      this.detailImgUrlarr = newdetailImgUrlarr;
      this.flag = this.detailImgUrlarr.length;
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob(data => {
        var canvas=document.getElementById("canvasa");
        var ctx=canvas.getContext("2d");
        let _URL = window.URL || window.webkitURL;
        var img=new Image();
        img.onload=start;
        img.src=_URL.createObjectURL(data);
        function start(){
          canvas.width=1200;
          canvas.height=675;
          var w=img.width;
          var h=img.height;
          var sizer=Math.min((canvas.width/w),(canvas.height/h));
          ctx.drawImage(img,0,0,w,h,0,0,w*sizer,h*sizer);
          var dataURL = canvas.toDataURL('image/png');
          var getRes = dataURL;//读取的结果在result中
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
          }
          var file = dataURLtoFile(getRes)
          that.beforeUnitPlan(file, that.distinguish)
        }
      })
    },
    /* oss 直传图片 */
    handleOss(val){
      let obj = { type: val };
      getOssFile(obj).then(data => {
        if (data.resultCode == 1) {
          let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
          let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
          let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
          let ossfile = data.resultObj.directory; // 保存路径
          let ossbucket = data.resultObj.bucket; // bucket
          localStorage.setItem('keyossId',ossId);
          localStorage.setItem('keyossSecret',ossSecret);
          localStorage.setItem('keyossHost',ossHost);
          localStorage.setItem('keyossfile',ossfile);
          localStorage.setItem('keyossbucket',ossbucket);
        }
      })
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    
  },
  created() {
    this.getInit(); // 查询列表
    this.getprovince(); // 所属城市
  }
}
</script>
<style scoped>
/* 评论列表分页 */
.paginationFy {
  width: 100%;
  height: 20px;
  text-align: right;
  margin-top: 10px;
}
/* 详情页 */
.decorationDiaryDiv {
  width: 95%;
  margin: 0 auto;
  padding: 10px 0;
}
.decorationDiaryElForm {
  width: 90%;
  margin: 10px 0;
  display:flex;
}
.dottedLine {
  width: 95%;
  margin: 20px auto;
  border-bottom: 2px dashed #ccc;
}
/* 刪除日志 */
.sahnchuDiv {
  width: 10%;
  position: absolute;
  right: 10px;
}
.primarybtn {
  width: 90%;
  margin: 20px auto;
  text-align: center;
}
/* 封面图 */
.upload .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.upload .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eeeeee;
  text-align: center;
}
/* 选择发布用户弹框内样式 */
.publishingUsers {
  width: 80%;
  display: flex;
  flex: 1;
}
.publisherBtn {
  height: 36px;
  line-height: 0;
  display: inline-block;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  margin-top: 5px;
  margin-right: 20px;
}
.releaseName {
  width: 160px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #888;
  margin-top: 5px;
  margin-right: 10px;
  text-align: right;
}
.fbrLogo {
  width: 12%;
  border-radius: 50%;
}
/* 发布用户 */
.disoutline {
  max-height: 260px;
  height: auto;
  overflow: auto;
  border: 1px solid #eee;
  padding: 0 15px 0 15px;
}
.disinline {
  position: relative;
  height: auto;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  cursor: pointer;
}
.disinline>img {
  width:50px;
  height:50px;
  cursor: pointer;
}
.disinline>span {
  margin-left: 10px;
  cursor: pointer;
}
.elRadio {
  position: absolute;
  top: 15px;
  right: 0px;
}
/* 多图 */
.upPictures {
  width: 100%;
}
.multigraph {
  width: 80px;
  height: 80px;
  position: relative;
  float:left;
  margin-right:10px;
  margin-top:5px;
  margin-bottom: 5px;
}
.chahao {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -7px;
  top: -7px;
  cursor: pointer;
}
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
  margin-top:5px;
}
</style>


// WEBPACK FOOTER //
// decoration.vue?f18e7f48